module.exports = __webpack_public_path__ + "img/wallet-brown.c8b3e5ae.svg";